<template>
  <div class="box-field" :class="{ error: error }">
    <textarea
      class="form-control text-input"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :disabled="disabled || !allowed"
      :error="error"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
    </textarea>
    <div class="box-field__count" v-if="allowed && !bottomText">
      {{$t('forms.symbol_limit')}}: {{ value.length }}/{{ maxlength }}
    </div>
    <div class="box-field__count" :class="{ 'highlight-text': highLightBottomText }" v-else-if="bottomText">
      {{ bottomText }}
    </div>
  </div>
</template>
<script>
export default {
  name: "TextInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowed: {
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: 300
    },
    error: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    bottomText: {
      type: String,
      default: ''
    },
    highLightBottomText: {
      type: Boolean,
      default: false
    }
  }
};
</script>
